<div class="m-b-7 m-t-9">
    @if (data) {
    <div class="add-ons wrap-x wrap-l pos-relative m-t">
        <div class="wrap-s wrap-m flex flex-justify-center m-b-6 m-b-4-s">
            <div class="flex flex-column flex-middle">
                @if (data.name) {
                <h2 class="left"
                    sizeClass="SM:h3, XL:h2"
                    [innerHTML]="data.name"></h2>
                }
                @if (data.subtitle) {
                <p class="left m-t-3 m-r-20 col-11"
                   sizeClass="SM:p2, XL:p1"
                   [innerHTML]="data.subtitle"></p>
                }
            </div>
        </div>
        <div class="products-carousel pos-relative m-t-9 m-t-0-m m-t-0-s">
            <swiper [slidesPerView]="client.sizeId > 1 ? 5 : 'auto'"
                    [scrollbar]="{draggable: true, horizontalClass: 'm-t-2'}"
                    [navigation]="{
                        nextEl: '.item-next-' + uid,
                        prevEl: '.item-prev-' + uid
                    }"
                    class="pos-relative m-t swiper-overflow-visible m-l-4-s m-l-4-m m-r-4-s m-r-4-m">
                @for (product of data.products; track $index; let index = $index) {
                @if (!product.model.isOutOfStock) {
                <ng-template class="w-5-s w-5-m p-r-2 m-b-6 m-b-2-m m-b-2-s"
                             swiperSlide>
                    <product class="w-12"
                             [model]="asLocalProduct(product.model)"
                             [forceOneImage]="client.isS || client.isM"
                             [listPosition]="index + 1"
                             [listName]="'Add-ons'"></product>
                </ng-template>
                }
                }
            </swiper>
        </div>
    </div>
    }


    <div class="wrap w-12 right flex flex-justify-center"
         style="bottom: 0.8rem"
         stickyNative>
        <a class="w-12-s button m-t-3 m-t-4-m m-t-4-s m-b-2 m-l-4-x m-l-4-l m-r-7-x m-r-7-l"
           [routerLink]="'/checkout'"
           translate>Continue to checkout</a>
    </div>
</div>